module.exports = __webpack_public_path__ + "static/img/4_1_8.24b5004.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/showcase/xi/booking/department/4_1_8.png
// module id = 8+Cm
// module chunks = 1